/**
 * <s-back-to-top> — Floating "Back to top" button.
 * Sets data-visible once the page has scrolled past roughly one screen, and
 * scrolls smoothly to the top on the --top command (instantly with reduced motion),
 * then moves focus to #main-content so keyboard users land at the top too.
 */
class SBackToTop extends HTMLElement {
  #ac;
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal, passive: true };
    const update = () => {
      this.#frame = 0;
      this.toggleAttribute('data-visible', window.scrollY > Math.max(600, window.innerHeight * 0.9));
    };
    window.addEventListener('scroll', () => {
      if (!this.#frame) this.#frame = requestAnimationFrame(update);
    }, opts);
    this.addEventListener('command', (event) => {
      if (event.command !== '--top') return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      document.getElementById('main-content')?.focus({ preventScroll: true });
    }, { signal: this.#ac.signal });
    update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    if (this.#frame) cancelAnimationFrame(this.#frame);
  }
}

if (!customElements.get('s-back-to-top')) {
  customElements.define('s-back-to-top', SBackToTop);
}
